module.exports = __webpack_public_path__ + "static/media/rock-1-D1.png";